import { useEffect, useState } from 'react';
import * as Icons from 'react-icons/hi';
import { LuEye, LuEyeOff } from 'react-icons/lu';
import { MdOutlineCancel } from 'react-icons/md';

interface InputProps {
  label: string;
  name: string;
  type?: string;
  className?: string;
  disabled?: boolean;
  required?: boolean;
  hasLabel?: boolean;
  placeHolder?: string;
  icon?: {
    iconName: string;
    color?: string;
    size?: number;
  };
  onChange: (value: any) => void;
  data?: any;
  onKeyDown?: (event: any) => void;
}

const Input = (props: InputProps) => {
  const [inputValue, setInputValue] = useState<any>(
    
  );
  const [showPassword, setShowPassword] = useState(false);

  const n = props.icon?.iconName ?? '';
  const IconComponent = (Icons as any)[n];

  useEffect(()=>{

    if(props.data)
    {
      if(props.type === 'date')
      {
        setInputValue(props.data);
      }
      else{
        setInputValue(props.data)
      }
    }

  }, [props.data])

  const handleChange = (e: any) => {
    setInputValue(e.target.value);
    props.onChange(e.target.value);
  };

  const handleClearInput = () => {
    setInputValue('');
    props.onChange(''); // Notify parent component of the cleared input
  };

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  
  return (
    <div
      className={`flex flex-col ${props.hasLabel && 'space-y-2'} relative my-2`}
    >
      {props.hasLabel && (
        <label className="text-xl">
          {props.label}{' '}
          <span className="text-red-600">{props.required ? '*' : ''}</span>
        </label>
      )}
      <span className="absolute top-3 left-4">
        {props.icon && (
          <IconComponent size={props.icon.size} color={props.icon.color} />
        )}
      </span>

      <input
        onKeyDown={props.onKeyDown}
        defaultValue={inputValue}
        value={inputValue}
        onChange={handleChange}
        placeholder={props.placeHolder}
        type={props.type === 'password' && showPassword ? 'text' : props.type}
        name={props.name}
        className={`h-24 md:h-16 border-[1px] px-4 py-2 rounded-md border-[#E4E4E7] ${
          props.icon ? 'pl-16' : 'pl-3'
        } ${props.className}`}
        disabled={props.disabled}
        required
      />

      {/* {inputValue && (
        <span
          className={`absolute top-1/2 transform -translate-y-1/2 ${
            props.type === 'datetime-local' || props.type === 'password'
              ? 'hidden'
              : 'right-0'
          } cursor-pointer text-gray-500`}
          onClick={handleClearInput}
        >
          <MdOutlineCancel size={20} />
        </span>
      )} */}

      {props.type === 'password' && (
        <span
          className="absolute bottom-5 right-4 cursor-pointer"
          onClick={handleTogglePassword}
        >
          {showPassword ? <LuEye /> : <LuEyeOff />}
        </span>
      )}
    </div>
  );
};

export default Input;
